import React from 'react';

import {
  Box,
  Button,
  IconButton,
  styled
} from '@mui/material';
import {
  BaseModal,
  fields,
  Form
} from 'iron-forge-react-modules';

import { Close } from '@mui/icons-material';
import { DateTime } from 'luxon';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const DateFieldController = fields.DateField.genControllerComponent<types.IFormState>();

const FormContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));



export interface IProps {
  storeId: string;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [fnExportAsn, tuple] = dataService.useExportAsnMutation(props.storeId);



  const form = useForm<types.IFormState>({
    defaultValues: {
      after: DateTime.now().minus({ days: 1 }).startOf('day').toJSDate(),
      before: DateTime.now().minus({ days: 1 }).endOf('day').toJSDate()
    }
  });



  const fnCloseButton: BaseModal.IProps['fnGenElTopCloseButton'] = ({ onClose }) => (
    <IconButton onClick={onClose}>
      <Close />
    </IconButton>
  );



  async function handleSubmit(formState: types.IFormState) {
    await fnExportAsn(formState);
    // props.onClose();
  }



  const content = (
    <Form.FC onSubmit={form.handleSubmit(handleSubmit)}>
      <FormContainerBox>
        <DateFieldController
          isDisabled={tuple.loading}
          formControl={form.control}
          label="Start"
          fieldKey="after" />

        <DateFieldController
          isDisabled={tuple.loading}
          formControl={form.control}
          label="End"
          fieldKey="before" />

        <ButtonBox>
          <Button
            disabled={tuple.loading}
            onClick={props.onClose}>
            Go Back
          </Button>

          <Button
            disabled={tuple.loading}
            type="submit"
            variant="contained">
            Submit
          </Button>
        </ButtonBox>
      </FormContainerBox>
    </Form.FC>
  );



  return (
    <BaseModal.FC
      isOpen
      fnGenElTopCloseButton={fnCloseButton}
      fnGenElCloseButton={fnCloseButton}>
      {() => content}
    </BaseModal.FC>
  );
};
